<template>
  <div class="content">
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-form-item label="机构名称" prop="orgName">
        <el-input placeholder="请填写机构名称" v-model="ruleForm.orgName"></el-input>
      </el-form-item>
      <el-form-item label="机构简称" prop="orgAbbreviation">
        <el-input placeholder="请填写机构简称" v-model="ruleForm.orgAbbreviation"></el-input>
      </el-form-item>
      <el-form-item label="成立时间" prop="orgEstablishmentDate">
        <el-date-picker
          v-model="ruleForm.orgEstablishmentDate"
          type="date"
          placeholder="选择成立时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="机构性质" prop="orgType">
        <el-select
          v-model="ruleForm.orgType"
          clearable
          placeholder="请选择机构性质"
          @change="selectChange('orgType', orgTypeList)"
        >
          <el-option
            v-for="item in orgTypeList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="投资阶段" prop="investmentStage">
        <el-select
          v-model="ruleForm.investmentStage"
          clearable
          placeholder="请选择投资阶段"
          @change="selectChange('investmentStage', levelOptions)"
        >
          <el-option
            v-for="item in levelOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="机构地址" prop="orgArea">
        <el-cascader
          :options="addroptions"
          v-model="ruleForm.orgArea"
          placeholder="请选择省市区"
          @change="orgAreaChange"
          clearable
          style="width: 100%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="orgAddress">
        <el-input placeholder="请填写机构详细地址" v-model="ruleForm.orgAddress"></el-input>
      </el-form-item>
      <el-form-item label="机构简介" prop="orgDescription">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入机构简介"
          v-model="ruleForm.orgDescription"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson">
        <el-input placeholder="请填写联系人" v-model="ruleForm.contactPerson"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contactInfo">
        <el-input placeholder="请填写联系方式" v-model="ruleForm.contactInfo"></el-input>
      </el-form-item>
       <el-form-item label="发布时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择发布时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-row>
        <el-col :span="24">
          <el-form-item label="logo" prop="logoSrc">
            <el-upload
              class="avatar-uploader"
              :action="this.uploadURL"
              name="file"
              :file-list="logoSrc"
              :show-file-list="false"
              :on-success="
                (response, file, fileList) =>
                  handlePictureCardPreview(response, file, fileList, 'logoSrc')
              "
              :before-upload="beforeAvatarUpload"
              :disabled="formDisabled"
            >
              <img
                v-if="ruleForm.logoSrc && logoSrc.length > 0"
                :src="logoSrc[0].url"
                class="img_border"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                :class="{ is_border: !ruleForm.logoSrc }"
              ></i>
              <span class="upload_btn" v-if="!ruleForm.logoSrc">上传图片</span>
              <span v-else class="upload_btn">更换图片</span>
            </el-upload>
            <span class="del_img" v-show="ruleForm.logoSrc && !formDisabled">
              <i class="el-icon-error" @click="deleteImg('logoSrc')"></i>
            </span>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="实景图" prop="realImageSrc">
            <el-upload
              class="avatar-uploader"
              :action="this.uploadURL"
              name="file"
              :show-file-list="false"
              :file-list="realImageSrc"
              :on-success="
                (response, file, fileList) =>
                  handlePictureCardPreview(response, file, fileList, 'realImageSrc')
              "
              :before-upload="beforeAvatarUpload"
              :disabled="formDisabled"
            >
              <img
                v-if="ruleForm.realImageSrc && realImageSrc.length > 0"
                :src="realImageSrc[0].url"
                class="img_border"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                :class="{ is_border: !ruleForm.realImageSrc }"
              ></i>
              <span class="upload_btn" v-if="!ruleForm.realImageSrc">上传图片</span>
              <span v-else class="upload_btn">更换图片</span>
            </el-upload>
            <span class="del_img" v-show="ruleForm.realImageSrc && !formDisabled">
              <i class="el-icon-error" @click="deleteImg('realImageSrc')"></i>
            </span>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="成功案例(logo)" prop="successCaseLogoSrc">
            <el-upload
              class="upload-demo"
              :action="this.uploadURL"
              multiple
              name="file"
              :file-list="fileList"
              :show-file-list="true"
              :on-success="handlePictureCardPreview2"
              :before-upload="beforeAvatarUpload"
              :on-remove="handlePictureCardRemove"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
      <el-form-item label="审批状态" prop="approvalStatus" style="text-align:left">
        <el-select
            v-model="ruleForm.approvalStatus"
            placeholder="请选择审核状态"
            style="display: block;"
            :disabled="formDisabled"
        >
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="不通过" :value="2"></el-option>
          <el-option label="退回" :value="3"></el-option>
          <el-option label="通过" :value="4"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';

export default {
  props: ['formDisabled', 'messageId'],
  components: {},
  data() {
    return{
      // orgTypeList: [],
      // levelOptions: [],
      ruleForm: {
        dataType: 3,
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgEstablishmentDate: null, // 机构成立日期
        // orgType: null, // 机构类型
        // orgTypeName: null,
        // investmentStage: null, // 投资阶段
        // investmentStageName: null, // 投资阶段名称
        orgArea: null, // 机构区域
        orgProvince: null, // 机构所在省
        orgCity: null, // 机构所在市
        orgDistrict: null, // 机构所在区域
        orgAddress: null, // 机构地址
        orgDescription: null, // 机构简介
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        publishedTime: null, // 发布时间
        logoSrc: null, // 机构Logo
        // realImageSrc: null, // 机构实景图
        // successCaseLogoSrc: null, // 成功案例(Logo)
        publishedFlag: false,
        approvalStatus: 4
      },
      rules: {
				orgName: [{
					required: true,
					message: "请填写机构名称",
					trigger: "blur"
				}],
        orgAbbreviation: [{
					required: true,
					message: "请填写机构简称",
					trigger: "blur"
				}],
        orgEstablishmentDate: [{
					required: true,
					message: "请选择机构成立日期",
					trigger: "change"
				}],
        // orgType: [{
				// 	required: true,
				// 	message: "请选择机构类型",
				// 	trigger: "change"
				// }],
        // investmentStage: [{
				// 	required: true,
				// 	message: "请选择投资阶段",
				// 	trigger: "change"
				// }],
        orgArea: [{
          required: true,
					message: "请选择机构所在区域",
					trigger: "blur"
        }],
        orgAddress: [{
          required: true,
					message: "请填写机构地址",
					trigger: "blur"
        }],
        orgDescription: [{
          required: true,
					message: "请填写机构简介",
					trigger: "blur"
        }],
        contactPerson: [{
          required: true,
					message: "请填写联系人",
					trigger: "blur"
        }],
        contactInfo: [{
          required: true,
					message: "请填写联系方式",
					trigger: "blur"
        }],
        logoSrc: [{
					required: true,
					message: "请选择机构Logo",
					trigger: "change"
				}],
        publishedTime: [{
					required: true,
					message: "请选择发布时间",
					trigger: "change"
				}]
			},
      addroptions: regionData,
      // fileList: [],
      logoSrc: [],
      // realImageSrc: []
    }
  },
  methods: {
    orgAreaChange(value) {
      if (value) {
        this.ruleForm.orgProvince = CodeToText[value[0]];
        this.ruleForm.orgCity = CodeToText[value[1]];
        this.ruleForm.orgDistrict = CodeToText[value[2]];
      }
    },
    // selectChange(prop, list){
    //   const item = list.find((item => item.value === this.ruleForm[prop]));
    //   if(item) {
    //     this.ruleForm[prop + 'Name'] = item.label
    //   }
    // },
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          // let successCaseLogoSrc = null
          // if(this.fileList && this.fileList.length > 0) {
          //   successCaseLogoSrc = JSON.stringify(this.fileList)
          // }
          const params = {
            ...this.ruleForm,
            publishedFlag: this.ruleForm.publishedFlag ? 1 : 0,
            // successCaseLogoSrc
          }
          e && e(params)
        }
      });
    },
    handlePictureCardPreview(response, file, fileList, type) {
      console.log(fileList)
			// this.ruleForm.logo = file.data.store_result;
      if (response.code == 0) {
        let arr = []
        if(fileList.length > 0) {
          // fileList.map(item => {
            arr.push({
              url: file.size ? this.imgUrl + file.response.data.store_result : file.url,
              name: file.name
            });
          // });
        }
        if(arr.length > 0) {
          this[type] = arr;
          this.ruleForm[type] = JSON.stringify(arr);
        }else{
          this.ruleForm[type] = '';
          this[type] = [];
        }
      }
		},
    // handlePictureCardPreview1(file) {
		// 	this.ruleForm.realImageSrc = file.data.store_result;
		// },
    // handlePictureCardPreview2(response, file, fileList) {
		// 	this.fileList = this.getList(fileList);
		// },
    // handlePictureCardRemove(file, fileList){
    //   this.fileList = this.getList(fileList);
    // },
    deleteImg(prop) {
      this[prop] = []
      this.ruleForm[prop] = null
    },
    beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 30;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 30MB!");
			}
			return type && isLt2M;
		},
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el.size ? this.imgUrl + el.response.data.store_result : el.url,
          uid: el.uid,
        };
      });
    },
    // getGroup() {
    //   this.http
    //     .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
    //       dictTypes: ['financial_institution_category', 'financial_investment_stage']
    //     })
    //     .then(res => {
    //       if (res.code === 0) {
    //         const { financial_institution_category, financial_investment_stage } = res.data;
    //         this.orgTypeList = [...financial_institution_category];
    //         this.levelOptions = [...financial_investment_stage]
    //       }
    //     });
    // },
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              dataType: 2,
              ...res.data
            };
            this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : []
            // this.realImageSrc = res.data.realImageSrc ? JSON.parse(res.data.realImageSrc) : []
            this.ruleForm.publishedFlag = Boolean(res.data.publishedFlag);
            // this.ruleForm.orgType = res.data.orgType + '';
            // this.ruleForm.investmentStage = res.data.investmentStage + '';

            if(res.data.orgProvince && TextToCode[res.data.orgProvince]) {
              const areas = [TextToCode[res.data.orgProvince].code, TextToCode[res.data.orgProvince][res.data.orgCity].code, TextToCode[res.data.orgProvince][res.data.orgCity][res.data.orgDistrict].code]
              this.ruleForm.orgArea = areas;
            }
            // if(res.data.successCaseLogoSrc) {
            //   this.fileList = JSON.parse(res.data.successCaseLogoSrc)
            // }
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
  },
  created() {
    // this.getGroup()
    if(this.messageId) {
      this.initDate(this.messageId)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  .del_img {
    position: absolute;
    top: -7px;
    left: 220px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }

  /deep/ .avatar-uploader {
    width: 243px;
    height: 198px;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .upload-demo {
    border: none;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  /deep/ .upload-demo {
    margin-top: 10px;
    /deep/.el-upload {
      /deep/.el-button {
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background: rgba(66, 141, 255, 1);
        border-radius: 18px;
        padding: 10px 25px;
      }
    }
  }
}
</style>
